// @flow

import type { Action } from 'app/common/redux/types';
import { report } from 'app/common/redux/lib/reportError';
import type { Dispatch, MiddlewareAPI, Store } from 'redux';

// $FlowFixMe: New error after Flow Upgrade http://pinch.pinadmin.com/flow53upgdoc
export default (store: MiddlewareAPI) => (next: Dispatch<any>) => (action: Action): Store => {
  if (action.type === 'ERROR_LOG_EVENT') {
    const { error, auxData } = action;
    report(error, auxData);
    return next(action);
  }
  // This will be the main way to catch and log errors once everything is migrated to react and
  // using the redux store.
  try {
    return next(action);
  } catch (error) {
    report(error || new Error('unknown error'), { action });
    return store.getState();
  }
};
